import { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import styles from '../../GlobalSearch.module.scss';
import CrossIcon from '../../../../assets/Svg/CrossIcon';
import TravelExplore from '../../../../assets/Svg/TravelExplore';
import { useOutsideClick } from '../../../../utils/constants/hooks';

function SearchBarAndIcon(props: {
    showSearch: boolean;
    onCrossIconClick: () => void;
    searchText: string;
    setSearchText: Dispatch<SetStateAction<string>>;
    onSearchIconClick: () => void;
    searchLoading?: boolean;
}) {
    const inputRef = useRef<HTMLInputElement>(null);
    useOutsideClick(inputRef, () => {
        props.onCrossIconClick();
    });
    useEffect(() => {
        if (props.showSearch) {
            setTimeout(() => {
                inputRef.current?.focus();
            });
        }
    }, [props.showSearch]);
    return (
        <>
            <span className={`${styles.SearchIcon} ${props.showSearch ? styles.SearchIconHidden : ''}`}>
                <TravelExplore height={20} width={20} />
            </span>

            <input
                ref={inputRef}
                value={props.searchText}
                onChange={(e) => props.setSearchText(e.target.value)}
                type="text"
                placeholder={props.showSearch ? 'Enter Name, CIN, LLPIN, PAN, GSTIN or website (min 3 char)' : 'Search/Add Lead'}
                className={props.showSearch ? styles.ShowSearch : styles.CompactSearch}
                id={'globalSearch'}
                onClick={() => {
                    if (!props.showSearch) {
                        props.onSearchIconClick();
                    }
                }}
            />
            {props.showSearch ? (
                <span
                    onMouseDown={(e) => {
                        e.stopPropagation();
                        if (!props.searchLoading) props.onCrossIconClick();
                    }}
                    className={styles.CrossIcon}
                >
                    {props.searchLoading ? (
                        <span className={styles.SearchLoader}>
                            <span className={styles.SearchLoaderSpinner} />
                        </span>
                    ) : (
                        <CrossIcon height={'12px'} width={'12px'} colour={'#6021b3'} />
                    )}
                </span>
            ) : null}
        </>
    );
}

export default SearchBarAndIcon;
